export default "__VITE_ASSET__DIjL5pmM__"